<p>trip-car-assignment-screen works!</p>
